




































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import OrderSearch from '@/app/components/FieldOrder/OrderSearch.vue'
import OrderTotal from '@/app/components/FieldOrder/OrderTotal.vue'
import OrderListHeader from '@/app/components/FieldOrder/OrderListHeader.vue'
import OrderList from '@/app/components/FieldOrder/OrderList.vue'
import OrderModalList from '@/app/components/FieldOrder/OrderModalList.vue'
import Pagination from '@/app/components/Common/Pagination.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import FieldOrderApi from '@/app/model/api/fieldOrderApi'
import FieldOrderModalApi from '@/app/model/api/fieldOrderModalApi'
/* module */
import { harvestStatus, plantingSeason, routerPath, errorFlag } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    ErrorModal,
    OrderSearch,
    OrderTotal,
    OrderListHeader,
    OrderList,
    OrderModalList,
    Pagination,
    Error409Modal,
    ConfirmModal,
    ErrorInfo
  }
})
export default class FieldOrder extends Vue {
  /* データ */
  private defaultData: any = {}
  private orderData: {[key: string]: any} = {
    cooperation_count: 0,
    harvest_instructions: 0,
    fields: []
  }
  private modalData: {[key: string]: any} = {
    cooperation_count: 0,
    harvest_instructions: 0,
    total_harvest: null,
    fields: []
  }
  private fieldOrderList: {[key: string]: any} = {}
  private modalOrderData: {[key: string]: any} = {}
  private defaultSeason: number = 0
  private isRequesting: boolean = false
  private beforeChangeData: {[key: string]: number} = {}
  private isOrderList: boolean = false
  private saveConfirmMessage: string = '<p>収穫指示/収穫済み以外の収穫ステータスに変更されるため<br/>収穫実績日は削除されます。<br/>よろしいですか？</p>'
  private currentPage: number = 1
  /* 並び替え */
  private yearAsc: boolean = true
  private seasonAsc: boolean = true
  private fieldIdAsc: boolean = true
  private fieldNameAsc: boolean = true
  private varietyAsc: boolean = true
  private gradeAsc: boolean = true
  private hervastAsc: boolean = true
  private growthHeightAsc: boolean = true
  private temperatureAsc: boolean = true
  private riceStatusAsc: boolean = true
  private statusAsc: boolean = true
  private plantingTypeAsc: boolean = true
  private plantingMethodAsc: boolean = true
  private modalYearAsc: boolean = true
  private modalSeasonAsc: boolean = true
  private modalFieldIdAsc: boolean = true
  private modalFieldNameAsc: boolean = true
  private modalVarietyAsc: boolean = true
  private modalGradeAsc: boolean = true
  private modalHervastAsc: boolean = true
  private modalGrowthHeightAsc: boolean = true
  private modalTemperatureAsc: boolean = true
  private modalRiceStatusAsc: boolean = true
  private modalStatusAsc: boolean = true
  private modalPlantingType: boolean = true
  private modalPlantingMethodAsc: boolean = true
  private changeStatusFieldId: number = 0
  private changeModalStatusFieldId: number = 0
  private isChangeList: boolean = false
  private isChangeModalList: boolean = false

  /* 表示非表示 */
  private showLoading: boolean = true
  private showNotFoundMessage: boolean = false
  private showModalNotFound: boolean = false
  private showOrderModal: boolean = false
  private showModalLoading: boolean = true
  private showError409Modal: boolean = false
  private showStatusChangeModal: boolean = false
  private showModalStatusChangeModal: boolean = false
  private changeStatusCheck: number = 0
  private changeModalStatusCheck: number = 0

  created () {
    /* 現在の年とシーズンを追加 */
    let year = new Date().getFullYear()

    this.getDefaultList(String(year))
  }

  private updateStatus (data: {[key: string]: number}) {
    for (let i in this.fieldOrderList) {
      if (this.fieldOrderList[i].planting_harvest_instruction_id === data.id) {
        this.fieldOrderList[i].harvest_status = harvestStatus.ON_HOLD
        this.fieldOrderList[i].harvest_actual_date = null
        this.fieldOrderList[i].time_stamp = data.time_stamp
      }
    }
  }

  private getBeforeStatus (data: {[key: string]: number}) {
    this.beforeChangeData = data
    this.isOrderList = true
    this.showError409Modal = true
  }

  private close409Modal () {
    // モーダルではなく一覧だった場合、元のステータスに戻す
    if (this.isOrderList) {
      for (let i in this.fieldOrderList) {
        if (this.fieldOrderList[i].planting_harvest_instruction_id === this.beforeChangeData.id) {
          this.fieldOrderList[i].harvest_status = this.beforeChangeData.status
          this.fieldOrderList[i].harvest_actual_date = this.beforeChangeData.date
          break
        }
      }
    }
    this.isOrderList = false
    this.showError409Modal = false
  }

  private getDefaultList (year: string) {
    (async () => {
      this.isRequesting = true
      let search: any = this.$refs.search
      let pagination: any = this.$refs.pagination
      if (search !== undefined && pagination !== undefined) {
        search.requesting = true
        pagination.requesting = true
      }
      const allStatus = [harvestStatus.NOT_DIRECTED, harvestStatus.ON_HOLD, harvestStatus.CHANCEL, harvestStatus.HARVESTE_INSTRUCTIONS, harvestStatus.HARVESTING, harvestStatus.HARVESTED]
      this.$store.commit('fieldOrderState/setCurrentPage', 1)
      this.currentPage = this.$store.state.fieldOrderState.currentPage

      const body = {
        year: year,
        season: [1, 2],
        harvestStatus: allStatus,
        variety: '',
        grade: '',
        word: '',
        flag: false,
        page: 1,
        order: 7,
        sort: 'desc'
      }

      const result = await FieldOrderApi.getFieldOrderData(body)

      // 初期値は草丈の降順なのでstateに保持する
      this.$store.commit('fieldOrderState/setOrderNum', 7)
      this.$store.commit('fieldOrderState/setSort', 'desc')

      if (result.isOk()) {
        this.defaultData = result.getPayload()
        this.orderData = result.getPayload()

        /* 草丈の降順に並び替え */
        this.fieldOrderList = this.orderData.fields

        /* 表示圃場が0の場合はメッセージを表示 */
        if (this.fieldOrderList.length === 0) {
          this.showNotFoundMessage = true
        } else {
          this.showNotFoundMessage = false
        }

        if (search !== undefined && pagination !== undefined) {
          search.requesting = false
          pagination.requesting = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.isRequesting = false
      this.showLoading = false
    })()
  }

  private getModalOrderData () {
    (async () => {
      this.modalOrderData = []
      this.showModalLoading = true
      this.isChangeModalList = true
      const result = await FieldOrderModalApi.getFieldOrderData(3, 'desc')

      // 初期値は草丈の降順なのでstateに保持する
      this.$store.commit('fieldOrderState/setModalOrderNum', 3)
      this.$store.commit('fieldOrderState/setModalSort', 'desc')

      if (result.isOk()) {
        let orderList = result.getPayload().fields
        this.modalData = result.getPayload()
        /* ステータスが収穫指示のものだけを抽出 */
        this.modalOrderData = orderList

        /* 連携圃場が0の場合はメッセージを表示 */
        if (this.modalOrderData.length === 0) {
          this.showModalNotFound = true
        } else {
          this.showModalNotFound = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showModalLoading = false
    })()
  }

  /* 検索 */
  private getOrderList () {
    (async () => {
      this.isRequesting = true
      let flag: boolean = false
      this.showLoading = true

      let search: any = this.$refs.search
      let pagination: any = this.$refs.pagination
      if (search !== undefined && pagination !== undefined) {
        search.requesting = true
        pagination.requesting = true
      }
      this.isChangeList = true

      /* 検索した場合は全て1ページ目に戻る */
      pagination.resetCurrentPage()
      this.$store.commit('fieldOrderState/setCurrentPage', 1)
      this.currentPage = this.$store.state.fieldOrderState.currentPage
      this.scrollTop()
      this.closeAllInner()

      if (this.$store.state.fieldOrderState.selectedVariety !== '' ||
      this.$store.state.fieldOrderState.selectedGrade !== '') {
        flag = true
      }

      const body = {
        year: this.$store.state.fieldOrderState.selectedYear,
        season: this.$store.state.fieldOrderState.selectedSeason,
        harvestStatus: this.$store.state.fieldOrderState.selectedStatus,
        variety: this.$store.state.fieldOrderState.selectedVariety,
        grade: this.$store.state.fieldOrderState.selectedGrade,
        word: this.$store.state.fieldOrderState.word,
        flag: flag,
        page: 1,
        order: 7,
        sort: 'desc'
      }

      // ソート初期値は草丈の降順(7=草丈)
      const result = await FieldOrderApi.getFieldOrderData(body)

      if (result.isOk()) {
        this.orderData = result.getPayload()

        /* 草丈の降順に並び替え */
        this.fieldOrderList = this.orderData.fields

        /* 表示圃場が0の場合はメッセージを表示 */
        if (this.orderData.fields.length === 0) {
          this.showNotFoundMessage = true
        } else {
          this.showNotFoundMessage = false
        }

        search.requesting = false
        pagination.requesting = false
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
      this.isRequesting = false
    })()
  }

  private getListNumber (key: number) {
    let page = this.$store.state.fieldOrderState.currentPage

    if (page === 1) {
      return key
    }

    return (50 * (page - 1)) + key
  }

  private scrollTop () : any {
    let area: any = document.getElementById('listContainer')!
    area.scrollTop = 0
  }

  private confirmChangeStatus (fieldId: number) {
    this.changeStatusFieldId = fieldId

    if (fieldId !== 0) {
      this.showStatusChangeModal = true
    }
  }

  private confirmChangeModalStatus (fieldId: number) {
    this.changeModalStatusFieldId = fieldId

    if (fieldId !== 0) {
      this.showModalStatusChangeModal = true
    }
  }

  private cancelChangeStatus () {
    this.showStatusChangeModal = false
    this.changeStatusCheck = 0
  }

  private cancelChangeModalStatus () {
    this.showModalStatusChangeModal = false
    this.changeModalStatusCheck = 0
  }

  private changeStatus () {
    this.changeStatusCheck = this.changeStatusFieldId
    this.showStatusChangeModal = false
  }

  private changeModalStatus () {
    this.changeModalStatusCheck = this.changeModalStatusFieldId
    this.showModalStatusChangeModal = false
  }

  /* リストのソート */
  private setSortData (val: number) {
    this.$store.commit('fieldOrderState/setOrderNum', val)
    switch (val) {
      // シーズン
      case 1:
        this.setAsc(this.seasonAsc)
        this.seasonAsc = !this.seasonAsc
        break
      // 圃場ID
      case 2:
        this.setAsc(this.fieldIdAsc)
        this.fieldIdAsc = !this.fieldIdAsc
        break
      // 圃場名
      case 3:
        this.setAsc(this.fieldNameAsc)
        this.fieldNameAsc = !this.fieldNameAsc
        break
      // 品種
      case 4:
        this.setAsc(this.varietyAsc)
        this.varietyAsc = !this.varietyAsc
        break
      // 等級
      case 5:
        this.setAsc(this.gradeAsc)
        this.gradeAsc = !this.gradeAsc
        break
      // 播種日
      case 6:
        this.setAsc(this.hervastAsc)
        this.hervastAsc = !this.hervastAsc
        break
      // 草丈
      case 7:
        this.setAsc(this.growthHeightAsc)
        this.growthHeightAsc = !this.growthHeightAsc
        break
      // 積算温度
      case 8:
        this.setAsc(this.temperatureAsc)
        this.temperatureAsc = !this.temperatureAsc
        break
      // 稲状態
      case 9:
        this.setAsc(this.riceStatusAsc)
        this.riceStatusAsc = !this.riceStatusAsc
        break
      // 収穫ステータス
      case 10:
        this.setAsc(this.statusAsc)
        this.statusAsc = !this.statusAsc
        break
      // 作付け種別
      case 11:
        this.setAsc(this.plantingTypeAsc)
        this.plantingTypeAsc = !this.plantingTypeAsc
        break
      // 栽培方法
      case 12:
        this.setAsc(this.plantingMethodAsc)
        this.plantingMethodAsc = !this.plantingMethodAsc
        break
      // 年
      case 13:
        this.setAsc(this.yearAsc)
        this.yearAsc = !this.yearAsc
        break

      default:
        break
    }
    this.sortOrderList()
  }

  /* モーダルのソート */
  private setModalSortData (val: number) {
    this.showModalLoading = true
    this.$store.commit('fieldOrderState/setModalOrderNum', val)
    switch (val) {
      // シーズン
      case 1:
        this.setModalAsc(this.modalSeasonAsc)
        this.modalSeasonAsc = !this.modalSeasonAsc
        break
      // 圃場ID
      case 2:
        this.setModalAsc(this.modalFieldIdAsc)
        this.modalFieldIdAsc = !this.modalFieldIdAsc
        break
      // 圃場名
      case 3:
        this.setModalAsc(this.modalFieldNameAsc)
        this.modalFieldNameAsc = !this.modalFieldNameAsc
        break
      // 品種
      case 4:
        this.setModalAsc(this.modalVarietyAsc)
        this.modalVarietyAsc = !this.modalVarietyAsc
        break
      // 等級
      case 5:
        this.setModalAsc(this.modalGradeAsc)
        this.modalGradeAsc = !this.modalGradeAsc
        break
      // 播種日
      case 6:
        this.setModalAsc(this.modalHervastAsc)
        this.modalHervastAsc = !this.modalHervastAsc
        break
      // 草丈
      case 7:
        this.setModalAsc(this.modalGrowthHeightAsc)
        this.modalGrowthHeightAsc = !this.modalGrowthHeightAsc
        break
      // 積算温度
      case 8:
        this.setModalAsc(this.modalTemperatureAsc)
        this.modalTemperatureAsc = !this.modalTemperatureAsc
        break
      // 稲状態
      case 9:
        this.setModalAsc(this.modalRiceStatusAsc)
        this.modalRiceStatusAsc = !this.modalRiceStatusAsc
        break
      // 収穫ステータス
      case 10:
        this.setModalAsc(this.modalStatusAsc)
        this.modalStatusAsc = !this.modalStatusAsc
        break
      // 作付け種別
      case 11:
        this.setModalAsc(this.modalPlantingType)
        this.modalPlantingType = !this.modalPlantingType
        break
      // 栽培方法
      case 12:
        this.setModalAsc(this.modalPlantingMethodAsc)
        this.modalPlantingMethodAsc = !this.modalPlantingMethodAsc
        break
      // 年
      case 13:
        this.setModalAsc(this.modalYearAsc)
        this.modalYearAsc = !this.modalYearAsc
        break

      default:
        break
    }

    this.sortModalOrderList()
  }

  /* ソートの昇順・降順をセット */
  private setAsc (flag: boolean) {
    if (flag) {
      this.$store.commit('fieldOrderState/setSort', 'asc')
    } else {
      this.$store.commit('fieldOrderState/setSort', 'desc')
    }
  }

  /* ソートの昇順・降順をセット */
  private setModalAsc (flag: boolean) {
    if (flag) {
      this.$store.commit('fieldOrderState/setModalSort', 'asc')
    } else {
      this.$store.commit('fieldOrderState/setModalSort', 'desc')
    }
  }

  /* 並び替え */
  private sortOrderList () {
    (async () => {
      this.isRequesting = true
      this.showLoading = true
      let flag: boolean = false

      this.scrollTop()
      this.closeAllInner()

      /* ソートした場合は全て1ページ目に戻る */
      let pagination: any = this.$refs.pagination
      pagination.resetCurrentPage()
      this.$store.commit('fieldOrderState/setCurrentPage', 1)
      this.currentPage = this.$store.state.fieldOrderState.currentPage

      if (this.$store.state.fieldOrderState.selectedVariety !== '' ||
      this.$store.state.fieldOrderState.selectedGrade !== '') {
        flag = true
      }

      const body = {
        year: this.$store.state.fieldOrderState.selectedYear,
        season: this.$store.state.fieldOrderState.selectedSeason,
        harvestStatus: this.$store.state.fieldOrderState.selectedStatus,
        variety: this.$store.state.fieldOrderState.selectedVariety,
        grade: this.$store.state.fieldOrderState.selectedGrade,
        word: this.$store.state.fieldOrderState.word,
        flag: flag,
        page: 1,
        order: this.$store.state.fieldOrderState.orderNum,
        sort: this.$store.state.fieldOrderState.sort
      }

      const result = await FieldOrderApi.getFieldOrderData(body)

      if (result.isOk()) {
        this.orderData = result.getPayload()

        /* 草丈の降順に並び替え */
        this.fieldOrderList = this.orderData.fields

        /* 表示圃場が0の場合はメッセージを表示 */
        if (this.orderData.fields.length === 0) {
          this.showNotFoundMessage = true
        } else {
          this.showNotFoundMessage = false
        }

        this.showLoading = false
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
      this.isRequesting = false
    })()
  }

  /* ページ移動 */
  private onPageChange (page: number) {
    (async () => {
      if (this.isRequesting) {
        return
      }

      let flag: boolean = false
      this.showLoading = true
      this.isChangeList = true

      this.scrollTop()
      this.closeAllInner()

      let search: any = this.$refs.search
      let pagination: any = this.$refs.pagination
      if (search !== undefined && pagination !== undefined) {
        search.requesting = true
        pagination.requesting = true
      }
      this.$store.commit('fieldOrderState/setCurrentPage', page)
      this.currentPage = this.$store.state.fieldOrderState.currentPage

      if (this.$store.state.fieldOrderState.selectedVariety !== '' ||
      this.$store.state.fieldOrderState.selectedGrade !== '') {
        flag = true
      }

      const body = {
        year: this.$store.state.fieldOrderState.selectedYear,
        season: this.$store.state.fieldOrderState.selectedSeason,
        harvestStatus: this.$store.state.fieldOrderState.selectedStatus,
        variety: this.$store.state.fieldOrderState.selectedVariety,
        grade: this.$store.state.fieldOrderState.selectedGrade,
        word: this.$store.state.fieldOrderState.word,
        flag: flag,
        page: page,
        order: this.$store.state.fieldOrderState.orderNum,
        sort: this.$store.state.fieldOrderState.sort
      }

      const result = await FieldOrderApi.getFieldOrderData(body)

      if (result.isOk()) {
        this.orderData = result.getPayload()
        this.showLoading = false

        /* 草丈の降順に並び替え */
        this.fieldOrderList = this.orderData.fields

        /* 表示圃場が0の場合はメッセージを表示 */
        if (this.orderData.fields.length === 0) {
          this.showNotFoundMessage = true
        } else {
          this.showNotFoundMessage = false
        }

        /* 連携圃場が0の場合はメッセージを表示 */
        if (this.modalOrderData.length === 0) {
          this.showModalNotFound = true
        } else {
          this.showModalNotFound = false
        }

        search.requesting = false
        pagination.requesting = false
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  /* モーダル並び替え */
  private sortModalOrderList () {
    (async () => {
      this.closeModalAllInner()

      const result = await FieldOrderModalApi.getFieldOrderData(this.$store.state.fieldOrderState.modalOrderNum, this.$store.state.fieldOrderState.modalSort)

      if (result.isOk()) {
        let orderList = result.getPayload().fields
        this.modalData = result.getPayload()

        /* ステータスが収穫指示のものだけを抽出 */
        this.modalOrderData = orderList

        /* 連携圃場が0の場合はメッセージを表示 */
        if (this.modalOrderData.length === 0) {
          this.showModalNotFound = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showModalLoading = false
    })()
  }

  /* 絞り込みのリセット */
  private resetRefine () {
    this.showLoading = true

    /* 検索した場合は全て1ページ目に戻る */
    let pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()
    this.isChangeList = true
    this.scrollTop()
    this.closeAllInner()
    this.$store.commit('fieldOrderState/setCurrentPage', 1)
    this.getDefaultList(this.$store.state.fieldOrderState.selectedYear)
  }

  private closeAllInner () {
    var el: any = this.$refs.test

    for (var i in el) {
      el[i].allClose(i)
    }
  }

  /* 全てのアコーディオンを開く */
  private showAllInner () {
    var el: any = this.$refs.test

    for (var i in el) {
      el[i].allExpand(i)
    }
  }

  private showModalAllInner () {
    var el: any = this.$refs.test2

    for (var i in el) {
      el[i].modalAllExpand(i)
    }
  }

  private closeModalAllInner () {
    var el: any = this.$refs.test2

    for (var i in el) {
      el[i].allClose(i)
    }
  }

  private showErrorInfo (text: string) {
    Vue.prototype.$alert.toast({ text: text, type: 1 })
  }

  private showModal () {
    this.getModalOrderData()
    this.showOrderModal = true
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number) {
    if (num === null) {
      return '-'
    } else {
      return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
  }

  private closeModal () {
    this.isChangeModalList = true
    this.showOrderModal = false
    this.modalOrderData = {}
  }
}
